import { propStylingCssAttrAliases, propStylingCssAttrNames } from './propStyling';
function isStylingPropName(propName) {
  const attrName = propName.replace('$', '');
  return propStylingCssAttrNames.includes(attrName) || propStylingCssAttrAliases.hasOwnProperty(attrName);
}

/**
 * Extracts the styling props from a set of props.
 * 
 * This function will return an array with two elements:
 * 1. An object with the styling props.
 * 2. An object with the non-styling props.
 * 
 * @param props - The props to extract the styling props from.
 * @returns An array with the styling props and the non-styling props.
 */
export function extractStylingProps(props) {
  const stylingProps = {};
  const nonStylingProps = {};
  for (const key of Object.keys(props)) {
    if (isStylingPropName(key)) {
      stylingProps[key] = props[key];
    } else {
      nonStylingProps[key] = props[key];
    }
  }
  return [stylingProps, nonStylingProps];
}
//# sourceMappingURL=propStylingUtils.js.map